import { useFeatureValue, type RemoteFeatureFlagOptions } from '@shared/core/featureFlags';

export type CashFundPartnerPlacement = 'shop' | 'giftTracker' | 'createFundDialog' | 'transferToBank' | 'transferToBankRepeat';

type CashFundPartnerPlacementResult = Readonly<{
  partner: string | null;
  loading: boolean;
}>;

export const isPlacementEnabled = (payload: unknown, partner: string | undefined, placement: CashFundPartnerPlacement): boolean => {
  if (!partner || !payload || typeof payload !== 'object') return false;
  const placements = (payload as Record<string, unknown>)[partner];
  if (!placements || typeof placements !== 'object') return false;
  return (placements as Record<string, unknown>)[placement] === true;
};

/** The active partner if the placements payload turns this placement on for it; null otherwise, including when the flag is off or the payload is missing. */
export const useCashFundPartnerPlacement = (placement: CashFundPartnerPlacement, options?: RemoteFeatureFlagOptions): CashFundPartnerPlacementResult => {
  const { value: activePartner, loading: activePartnerLoading } = useFeatureValue('activeCashFundPartner', options);
  const { value: placementsValue, payload, loading: placementsLoading } = useFeatureValue('cashFundPartnerPlacements', options);
  return {
    partner: activePartner && placementsValue === 'on' && isPlacementEnabled(payload, activePartner, placement) ? activePartner : null,
    loading: activePartnerLoading || placementsLoading,
  };
};
